import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectionType } from '@swimlane/ngx-datatable';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import { CREDIT_CATEGORY_RECORD } from '../../../helpers/CreditCategory';
import { CreditCategory } from '../../../../lib/lib-shared/types/CreditCategory';
import { CreditType } from '../../../../lib/lib-shared/types/CreditType';
import { ApiLavandierService } from '../../../../lib/lib-ngx/web-services/api-lavandier.service';
import { PRICEMULTIPLIER } from '../../../../lib/lib-shared/defines';

@Component({
  selector: 'lm-order-create-credit',
  templateUrl: './order-create-credit.component.html',
  styleUrls: ['./order-create-credit.component.scss']
})
export class OrderCreateCreditComponent implements OnInit {
  public SelectionType = SelectionType;
  public CreditType = CreditType;
  public CreditCategory: CreditCategory[] = Object.values(CreditCategory).filter(creditCategory => creditCategory !== CreditCategory.PREORDER);
  public CREDIT_CATEGORY_RECORD = CREDIT_CATEGORY_RECORD;
  public creditForm: FormGroup;

  @Output() public cancel = new EventEmitter<any>();
  @Input() public userId: number;
  @Input() public orderId: number;

  public conversationList = [];

  constructor(
    private apiLavandierService: ApiLavandierService,
    private fb: FormBuilder,
    private ngbDateParserFormatter: NgbDateParserFormatter,
  ) {
  }

  ngOnInit() {
    this.buildForm();

    this.apiLavandierService.getUserIntercomConversation(this.userId)
      .subscribe((conversationList: any) => this.conversationList = conversationList);
  }

  buildForm() {
    this.creditForm = this.fb.group({
      amount: [null, Validators.required],
      type: [CreditType.MINUS, Validators.required],
      category: [null, Validators.required],
      description: ['', Validators.required],
      conversationId: ['', Validators.required],
      startedAt: [this.ngbDateParserFormatter.parse(moment().format()), Validators.required],
      endedAt: [this.ngbDateParserFormatter.parse(moment().add(1, 'months').format()), Validators.required],
    });
  }

  onSelect({selected}) {
    this.creditForm.controls['conversationId'].patchValue(selected[0].id);
  }

  onAddCredit() {
    this.apiLavandierService.postCredit({
      userId: this.userId,
      orderId: this.orderId,
      type: this.creditForm.value.type,
      category: this.creditForm.value.category,
      description: this.creditForm.value.description,
      amount: this.creditForm.value.amount * PRICEMULTIPLIER,
      conversationId: this.creditForm.value.conversationId,
      startedAt: this.ngbDateParserFormatter.format(this.creditForm.value.startedAt),
      endedAt: this.ngbDateParserFormatter.format(this.creditForm.value.endedAt),
    })
      .subscribe(() => this.cancel.emit());
  }
}
